import {
  useQuery,
  UseQueryResult,
  UseQueryOptions,
} from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import { buildQueryString } from "@mimber-client/utils"
import {
  OrderWithRelationsDto,
  ResponseDto,
  QueryParamsDto,
} from "@mimber/schema"
import { ordersKeys } from "../orders.utils"

export type UseOrdersParams = QueryParamsDto

export const useOrders = (
  params?: UseOrdersParams,
  options?: UseQueryOptions<ResponseDto<OrderWithRelationsDto[]>, Error>
): UseQueryResult<ResponseDto<OrderWithRelationsDto[]>, Error> => {
  guardAppUsage("mimber-organization", "useOrders")

  const { server } = useServerContext()

  return useQuery({
    queryKey: ordersKeys.findAll(params),
    queryFn: async () => {
      const response = await server.get<ResponseDto<OrderWithRelationsDto[]>>(
        buildQueryString("orders", params)
      )
      return response.data
    },
    staleTime: 1 * 60 * 1000,
    ...options,
  })
}
